import { Fragment, useContext } from "react";
import classes from "./LocationItemGroup.module.css";
import { PopularCityItem } from "./PopularCityItem";
import { GroupHeading } from "../AirportSelection/AirportSelection";
import { useDispatch } from "react-redux";
import { ModalElementContext } from "src/context/modal-element-context";
import { searchDataActions } from "src/store/search";

import DotPulseLoader from "src/components/UI/DotPulseLoader/DotPulseLoader";
import { useLocaleContext } from "src/context/locale-context";
import { useDeviceContext } from "src/context/device-context";
import { airportsApi } from "src/services/api";

export function PopularCityItemGroup({ title, items, isDeparture }) {
  const dispatch = useDispatch();
  const { onClose, targetTripId, dispatchLocalState, isResultsModal } =
    useContext(ModalElementContext);
  const { currentLanguage, getStringRes } = useLocaleContext();
  const { isMobile } = useDeviceContext();

  const onSelectHandler = async (location) => {
    console.log("onSelectHandler DISPATCH " + location.city);
    let lang = currentLanguage.toUpperCase();
    let airports = [];
  try {
    const res = await airportsApi.getAirports(`city=${location.cityIata}`, "EN");
    const cityData = res.data?.[0];
    if (cityData?.airport?.length > 0) {
      airports = cityData.airport.map((a) => a.iata);
    }
  } catch (err) {
    console.log("Failed to fetch airports:", err);
  }

    if (isResultsModal) {
      dispatchLocalState({
        type: "UPDATE_TRIP",
        id: targetTripId,
        payload: {
          [isDeparture ? "srcLocation" : "destLocation"]: {
            city: location.city,
            iata: location.iata,
            cityIata: location.cityIata,
            isCity: true,
            names: location.names,
            airports: airports,
          },
        },
      });
      dispatch(
        searchDataActions.updateUserInputTrip({
          tripId: targetTripId,
          input: {
            [isDeparture ? "srcLocation" : "destLocation"]: location.names[lang],
            [isDeparture ? "srcIata" : "destIata"]: location.iata,
          },
        })
      );
    } else {
      const payload = {
        tripId: targetTripId,
        location: { ...location, airports },
        isCity: true,
        lang: lang,
      };
      if (isDeparture) {
        dispatch(searchDataActions.updateSrcLocation(payload));
      } else {
        dispatch(searchDataActions.updateDestLocation(payload));
      }
    }
    onClose();
  };

  return (
    <Fragment>
      <GroupHeading title={title} />

      {!items || items.length === 0 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: isMobile ? "1.75rem" : "0",
            paddingBottom: "1rem",
          }}>
          {items && items.length === 0 && <DotPulseLoader opacity={0.4} />}
          {items === null && (
            <span style={{ color: "var(--ui-5)" }}>
              {getStringRes("airport.search.popular.none")}
            </span>
          )}
        </div>
      ) : (
        <ul className={`${classes.cityList} ${classes.container}`}>
          {items.map((item) => (
            <PopularCityItem key={item.city} item={item} onSelectCity={onSelectHandler} />
          ))}
        </ul>
      )}
    </Fragment>
  );
}
